import React, { ReactNode, useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { UseSidebar } from '../../hook/SidebarHook';
import SidebarComponent from '../sidebar/SidebarComponent';
import LoadingComponent from '../loading/LoadingComponent';
import { UseAuth } from '../../hook/AuthHook';
import { useNavigate } from 'react-router-dom';

interface ContainerSideBarComponentProps {
  children: ReactNode;
}

/**
 * ContainerSideBarComponent - Componente de menu lateral com container responsivo
 * @param children
 * @constructor
 */
const ContainerSideBarComponent: React.FC<ContainerSideBarComponentProps> = ({ children }) => {
  const { open } = UseSidebar();
  let navigate = useNavigate();
  const avatar = 'https://gravatar.com/avatar/9d6cbf90c3a007688af389adf8ca038d?s=400&d=identicon&r=x';
  const { loggedUserData } = UseAuth();

  const [user, setUser] = useState<any>({
    id: 0,
    name: '',
    login: '',
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (loggedUserData !== undefined) {
      setUser(loggedUserData);
    }
  }, [loggedUserData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Define telas menores que 768px como mobile
    };

    handleResize(); // Chamada inicial
    window.addEventListener('resize', handleResize); // Adiciona event listener para atualizar em tempo real

    return () => {
      window.removeEventListener('resize', handleResize); // Limpa event listener
    };
  }, []);

  return (
    <Container fluid>
      <>{console.log('isMobile > ', isMobile)}</>
      <LoadingComponent>
        {isMobile ? (
          // Exibição para dispositivos móveis, sem as Cols
          <Row>
            <SidebarComponent />
            <Container fluid className="d-flex justify-content-end align-items-center mb-3">
              <div style={{ display: 'flex', alignItems: 'center', fontSize: isMobile ? '0.8rem' : '1rem' }}>
                <img src={avatar} alt="User" style={{ borderRadius: '50%', marginRight: '10px', width: '35px', height: '35px' }} />
                <span style={{ marginRight: '10px', fontSize: isMobile ? '0.8rem' : '1rem' }}>{user.login}</span>
                <Button
                  variant="outline-danger"
                  style={{ fontSize: isMobile ? '0.7rem' : '1rem' }}
                  onClick={() => {
                    localStorage.clear();
                    navigate('/');
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                  }}>
                  Sair
                </Button>
              </div>
            </Container>
            <Container fluid>{children}</Container>
          </Row>
        ) : (
          <Row>
            <Col sm={open ? 2 : 1}>
              <SidebarComponent />
            </Col>
            <Col sm={open ? 10 : 11} className="p-3">
              <Container fluid className="d-flex justify-content-end align-items-center mb-3">
                <div style={{ display: 'flex', alignItems: 'center', fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  <img src={avatar} alt="User" style={{ borderRadius: '50%', marginRight: '10px', width: '40px', height: '40px' }} />
                  <span style={{ marginRight: '10px', fontSize: isMobile ? '0.8rem' : '1rem' }}>{user.login}</span>
                  <Button
                    variant="outline-danger"
                    style={{ fontSize: isMobile ? '0.7rem' : '1rem' }}
                    onClick={() => {
                      localStorage.clear();
                      navigate('/');
                      // eslint-disable-next-line no-restricted-globals
                      location.reload();
                    }}>
                    Sair
                  </Button>
                </div>
              </Container>
              <Container fluid>{children}</Container>
            </Col>
          </Row>
        )}
      </LoadingComponent>
    </Container>
  );
};

export default ContainerSideBarComponent;
